import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import "./config/axiosConfig";

const firebaseConfig = {
  apiKey: "AIzaSyAZkTuVv0kV1ZjOJXl8ZXCXwfjGb9ZaFrc",
  authDomain: "cleancycle-7e584.firebaseapp.com",
  projectId: "cleancycle-7e584",
  storageBucket: "cleancycle-7e584.appspot.com",
  messagingSenderId: "559656045605",
  appId: "1:559656045605:web:99e891ab20fb016e0d43cc",
  measurementId: "G-8MTNG5DKWZ",
};

initializeApp(firebaseConfig);

// Local tests only: sign in against the Firebase Auth emulator. The variable
// is never set for a deployed build.
if (process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_HOST) {
  connectAuthEmulator(
    getAuth(),
    `http://${process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_HOST}`,
    { disableWarnings: true }
  );
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
